import clsx from 'clsx';
import React, { useState } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useStyles } from './styles';
import PharmasContentMobile from '../PharmasContentMobile';
import MedicalContentMobile from '../MedicalContentMobile';
import AcademicContentMobile from '../AcademicContentMobile';

export default function MainContentMobile() {
  const [stateContent, setStateContent] = useState(1);
  const classes = useStyles();

  return (
    <>
      <Box bgcolor="#EEEEEE">
        <Container>
          <Box pt={4} pb={2} px={6}>
            <Typography variant="h6" component="p" align="center" style={{ lineHeight: 1.2 }}>
              <b>
                {stateContent === 1 && 'Solutions for Academic Institutions'}
                {stateContent === 2 && 'Solutions for Pharma companies & Biotechs'}
                {stateContent === 3 && 'Solutions for Scientific societies'}
              </b>
            </Typography>

            <Box px={1} pt={1}>
              <Typography variant="body1" align="center" style={{ lineHeight: 1.2 }}>
                {stateContent === 1 && 'Inspire new scientific outcomes across your institution'}
                {stateContent === 2 &&
                  'Produce professional designs for an accurate scientific communication'}
                {stateContent === 3 &&
                  "Incorporate Mind the Graph to your associates' benefits list"}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" justifyContent="center" pb={2}>
            <Button
              className={clsx(classes.buttonStateContent, {
                [classes.buttonStateContentSelected]: stateContent === 1,
              })}
              disableRipple
              onClick={() => setStateContent(1)}
            >
              Academic Institutions
            </Button>

            <Box mx={0.5}>
              <Button
                className={clsx(classes.buttonStateContent, {
                  [classes.buttonStateContentSelected]: stateContent === 2,
                })}
                disableRipple
                onClick={() => setStateContent(2)}
              >
                Pharmas and Biotechs
              </Button>
            </Box>

            <Button
              className={clsx(classes.buttonStateContent, {
                [classes.buttonStateContentSelected]: stateContent === 3,
              })}
              disableRipple
              onClick={() => setStateContent(3)}
            >
              Scientific societies
            </Button>
          </Box>
        </Container>
      </Box>

      <Box
        className={clsx(classes.contentTransition, {
          [classes.contentHidden]: stateContent !== 1,
        })}
      >
        <AcademicContentMobile />
      </Box>

      <Box
        className={clsx(classes.contentTransition, {
          [classes.contentHidden]: stateContent !== 2,
        })}
      >
        <PharmasContentMobile />
      </Box>

      <Box
        className={clsx(classes.contentTransition, {
          [classes.contentHidden]: stateContent !== 3,
        })}
      >
        <MedicalContentMobile />
      </Box>
    </>
  );
}
